import { ButtonHTMLAttributes, forwardRef } from 'react'
import { cn } from '@utils'
import { ActionVariant } from '@/constants'

type OmpButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ActionVariant
  fullWidth?: boolean
}

const OmpButton = forwardRef<HTMLButtonElement, OmpButtonProps>(
  ({ variant = ActionVariant.Primary, fullWidth = false, className, type = 'button', children, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={cn('omp-btn', `omp-btn-${variant}`, fullWidth && 'omp-btn-block', className)}
        {...rest}>
        {children}
      </button>
    )
  }
)

OmpButton.displayName = 'OmpButton'

export default OmpButton
